import TrackingUtils from "@tracking/utils/TrackingUtils";
import {
  transformInObjectArray,
  compileDataIndicadores,
} from "../slices/utils";

export const dataCrlMatrizDecisaoReducer = (state, action) => {
  const {
    enquadramentos,
    listaAgingAjustada,
    listaAgingPrometida,
    listaApelidoTransportadora,
    listaBandeiraDescricao,
    listaCritico,
    listaIdFilial,
    listaReclamacao,
    listaTempoEmEtapa,
    listaTipoDeCarga,
    listaTipoEntregaDescricao,
    listaUfOrigem,
    listaUfDestino,
    listaUnidadeDeNegocioDescricao,
    listaAtuacao,
    listaSituacao,
    ofensoresAgilizar,
    ofensoresCritico,
    ofensoresIndenizatorio,
    ofensoresMonitorar,
    quantidadeTotalPedidos,
    valorTotalPedidos,
  } = action.payload.items[0];

  state.dataCrlMatrizDecisao.dataAcoes = {
    enquadramentos: enquadramentos,
    ofensoresAgilizar,
    ofensoresCritico,
    ofensoresIndenizatorio,
    ofensoresMonitorar,
    ofensores: [
      {
        tipoOfensor: "ofensoresIndenizatorio",
        pieColor: "177, 88, 86",
        ...ofensoresIndenizatorio,
      },
      {
        tipoOfensor: "ofensoresCritico",
        pieColor: "247, 150, 71",
        ...ofensoresCritico,
      },
      {
        tipoOfensor: "ofensoresAgilizar",
        pieColor: "241, 241, 39",
        ...ofensoresAgilizar,
      },
      {
        tipoOfensor: "ofensoresMonitorar",
        pieColor: "88, 195, 60",
        ...ofensoresMonitorar,
      },
    ],
    quantidadeTotalPedidos,
    valorTotalPedidos,
  };

  state.dataCrlMatrizDecisao.filters = {
    listaAgingAjustada: transformInObjectArray(listaAgingAjustada),
    listaAgingPrometida: transformInObjectArray(listaAgingPrometida),
    listaApelidoTransportadora: transformInObjectArray(
      listaApelidoTransportadora
    ),
    listaBandeiraDescricao: transformInObjectArray(listaBandeiraDescricao),
    listaCritico: transformInObjectArray(listaCritico),
    listaIdFilial: transformInObjectArray(listaIdFilial),
    listaReclamacao: transformInObjectArray(listaReclamacao),
    listaTempoEmEtapa: transformInObjectArray(listaTempoEmEtapa),
    listaTipoDeCarga: transformInObjectArray(listaTipoDeCarga),
    listaTipoEntregaDescricao: transformInObjectArray(
      listaTipoEntregaDescricao
    ),
    listaUfOrigem: transformInObjectArray(listaUfOrigem),
    listaUfDestino: transformInObjectArray(listaUfDestino),
    listaUnidadeDeNegocioDescricao: transformInObjectArray(
      listaUnidadeDeNegocioDescricao
    ),
    listaAtuacao: transformInObjectArray(listaAtuacao),
    listaSituacao: transformInObjectArray(listaSituacao),
  };
};

export const dataCrlMatrizDecisaoByFiltersReducer = (state, action) => {
  const {
    enquadramentos,
    ofensoresAgilizar,
    ofensoresCritico,
    ofensoresIndenizatorio,
    ofensoresMonitorar,
    quantidadeTotalPedidos,
    valorTotalPedidos,
  } = action.payload.items[0];

  state.dataCrlMatrizDecisao.dataAcoes = {
    enquadramentos: enquadramentos,
    ofensoresAgilizar,
    ofensoresCritico,
    ofensoresIndenizatorio,
    ofensoresMonitorar,
    ofensores: [
      {
        tipoOfensor: "ofensoresIndenizatorio",
        pieColor: "177, 88, 86",
        ...ofensoresIndenizatorio,
      },
      {
        tipoOfensor: "ofensoresCritico",
        pieColor: "247, 150, 71",
        ...ofensoresCritico,
      },
      {
        tipoOfensor: "ofensoresAgilizar",
        pieColor: "241, 241, 39",
        ...ofensoresAgilizar,
      },
      {
        tipoOfensor: "ofensoresMonitorar",
        pieColor: "88, 195, 60",
        ...ofensoresMonitorar,
      },
    ],
    quantidadeTotalPedidos,
    valorTotalPedidos,
  };

  state.dataCrl.configTabs.filtersForDetails = {
    ...state.dataCrl.configTabs.filtersForDetails,
    ...action.meta.arg,
  };
};

export const dataCrlMatrizDecisaoIndicadoresReducer = (state, action) => {
  const { item } = action.payload;

  state.dataCrlMatrizDecisao.dataIndicadores = {
    indicadorDiarioLista: compileDataIndicadores(
      item?.indicadorDiarioLista ?? []
    ),
    cardsIndicadores: [
      {
        tipoCard: "cardIndicadorAtraso",
        title: "Atraso",
        pedidos: item?.totalAtraso ?? 0,
        valorTotal: TrackingUtils.percent(
          item?.valorTotalAtraso ?? 0,
          item?.valorTotalValor ?? 0
        ),
        icon: "watch_later",
        colorHex: "#B15856",
        colorRGB: "223, 204, 204",
        isPercent: true,
      },
      {
        tipoCard: "cardIndicadorBacklog",
        title: "Backlog",
        pedidos: item?.totalBacklog ?? 0,
        valorTotal: TrackingUtils.percent(
          item?.valorTotalBacklog ?? 0,
          item?.valorTotalValor ?? 0
        ),
        icon: "library_books",
        colorHex: "#0033C6",
        colorRGB: "18, 79, 98",
        isPercent: true,
      },
      {
        tipoCard: "cardIndicadorValor",
        title: "Total",
        pedidos: item?.totalValor ?? 0,
        valorTotal: item?.valorTotalValor ?? 0,
        icon: "equalizer",
        colorHex: "#F93C90",
        colorRGB: "249, 60, 144",
        isPercent: false,
      },
    ],
  };
};
